module.exports = __webpack_public_path__ + "img/banner_2025.c58c4190.jpg";